import { useState } from "react";
import { Calendar as CalendarIcon, X } from "lucide-react";
import { format } from "date-fns";
import { id as idLocale } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

function toDate(value) {
  if (!value) return undefined;
  const d = new Date(value + "T00:00:00");
  return isNaN(d.getTime()) ? undefined : d;
}

function toStr(date) {
  if (!date) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export default function DatePicker({ value, onChange, placeholder = "Pilih tanggal", testid }) {
  const [open, setOpen] = useState(false);
  const date = toDate(value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full flex items-center gap-2 px-4 py-2.5 border c-input rounded-lg text-sm outline-none focus:border-gold focus:ring-1 focus:ring-gold transition text-left"
        >
          <CalendarIcon className="w-4 h-4 text-gold shrink-0" strokeWidth={1.6} />
          <span className={`flex-1 font-mono ${date ? "c-strong" : "text-[#A0A0A0]"}`}>
            {date ? format(date, "dd MMM yyyy", { locale: idLocale }) : placeholder}
          </span>
          {date && (
            <X
              className="w-3.5 h-3.5 text-[#A0A0A0] hover:text-wine"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
            />
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-xl" align="start">
        <Calendar
          mode="single"
          selected={date}
          onSelect={(d) => { onChange(toStr(d)); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
